import React from "react";
import { Sparkles, X } from "lucide-react";

export const MicrobiomeExtractModal = ({ modal, setModal, toggleRow, updateRow, confirmSave }) => {
  if (!modal) return null;
  return (
    <div className="fixed inset-0 z-50 bg-[#2D322B]/80 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto" data-testid="microbiome-extract-modal">
      <div className="bg-[#F9F6F0] rounded-3xl max-w-4xl w-full my-8 max-h-[90vh] flex flex-col">
        <div className="flex items-start justify-between p-6 border-b border-[#D1C7B8]">
          <div className="flex items-start gap-3">
            <Sparkles className="w-5 h-5 text-[#D49A44] mt-1" />
            <div>
              <p className="label-eyebrow text-[#D49A44]">Gemini 3 Pro · Bioscreen FMA</p>
              <h2 className="font-serif text-2xl text-[#2D322B] mt-1">Confirm your gut analysis</h2>
              <p className="text-sm text-[#5C6359] mt-1">Found {modal.organisms.length} organisms. Uncheck anything that looks off — edit inline.</p>
            </div>
          </div>
          <button onClick={() => setModal(null)} data-testid="microbiome-modal-close" className="text-[#5C6359] hover:text-[#C05C42]"><X className="w-5 h-5" /></button>
        </div>

        <div className="px-6 py-4 grid grid-cols-1 md:grid-cols-2 gap-4 border-b border-[#D1C7B8]">
          <div>
            <label className="text-[10px] uppercase tracking-widest text-[#5C6359] block mb-1">Lab / Provider</label>
            <input value={modal.labName} onChange={(e) => setModal((m) => ({ ...m, labName: e.target.value }))} data-testid="microbiome-lab-name"
              className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-1 outline-none text-[#2D322B] font-serif" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest text-[#5C6359] block mb-1">Report date</label>
            <input type="date" value={modal.labDate?.slice(0, 10) || ""} onChange={(e) => setModal((m) => ({ ...m, labDate: e.target.value }))} data-testid="microbiome-lab-date"
              className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-1 outline-none text-[#2D322B] font-serif" />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <table className="w-full text-sm">
            <thead className="text-[10px] uppercase tracking-widest text-[#5C6359]">
              <tr>
                <th className="text-left pb-2 w-8"></th>
                <th className="text-left pb-2">Organism</th>
                <th className="text-left pb-2 w-24">Count</th>
                <th className="text-left pb-2 w-24">Unit</th>
                <th className="text-left pb-2 w-28">Ref range</th>
              </tr>
            </thead>
            <tbody>
              {modal.organisms.map((o, i) => {
                const checked = modal.selected.has(i);
                return (
                  <tr key={`${o.organism}-${i}`} className={`border-t border-[#D1C7B8] ${checked ? "" : "opacity-40"}`} data-testid={`microbiome-row-${i}`}>
                    <td className="py-2"><input type="checkbox" checked={checked} onChange={() => toggleRow(i)} data-testid={`microbiome-check-${i}`} className="accent-[#C05C42] w-4 h-4" /></td>
                    <td className="py-2 pr-3"><input value={o.organism} onChange={(e) => updateRow(i, "organism", e.target.value)} className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#2D322B] font-serif" /></td>
                    <td className="py-2 pr-3"><input value={o.count ?? ""} onChange={(e) => updateRow(i, "count", e.target.value)} className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#C05C42]" /></td>
                    <td className="py-2 pr-3"><input value={o.unit ?? ""} onChange={(e) => updateRow(i, "unit", e.target.value)} className="w-full bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#5C6359]" /></td>
                    <td className="py-2">
                      <div className="flex items-center gap-1">
                        <input value={o.reference_low ?? ""} onChange={(e) => updateRow(i, "reference_low", e.target.value)} placeholder="low" className="w-10 bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#5C6359] text-xs" />
                        <span className="text-[#9A8F7E]">–</span>
                        <input value={o.reference_high ?? ""} onChange={(e) => updateRow(i, "reference_high", e.target.value)} placeholder="high" className="w-10 bg-transparent border-b border-transparent focus:border-[#C05C42] py-1 outline-none text-[#5C6359] text-xs" />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="border-t border-[#D1C7B8] p-6 flex items-center justify-between">
          <p className="text-xs text-[#5C6359]" data-testid="microbiome-selected-count">{modal.selected.size} of {modal.organisms.length} selected</p>
          <div className="flex gap-3">
            <button onClick={() => setModal(null)} className="btn-secondary !py-2 !px-5" data-testid="microbiome-cancel">Cancel</button>
            <button onClick={confirmSave} className="btn-primary !py-2 !px-5" data-testid="microbiome-confirm">Save analysis</button>
          </div>
        </div>
      </div>
    </div>
  );
};
